import http from "../../../services/http";
import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import {
  IAPI_FAC030_Request,
  IAPI_FAC030_Response,
  IAPI_FAC031_Request,
  IAPI_FAC031_Response,
  IAPI_FAC014_Request,
  IAPI_FAC014_Response,
} from "../../../type/apiType";

// 施設表示順更新(申請施設)
const httpAPI_FAC030 = async (
  param: IAPI_FAC030_Request
): Promise<IAPI_FAC030_Response> => {
  let res = await http.post(ApiUrl.API_FAC030, {
    ...param,
  });
  return res.data;
};

// 申請施設一覧参照
const httpAPI_FAC031 = async (
  param: IAPI_FAC031_Request
): Promise<IAPI_FAC031_Response> => {
  let res = await http.post(ApiUrl.API_FAC031, {
    ...param,
  });
  return res.data;
};

// 施設情報削除API
// API仕様書_施設
const httpAPI_FAC014 = async (
  param: IAPI_FAC014_Request
): Promise<IAPI_FAC014_Response> => {
  let res = await http.post(ApiUrl.API_FAC014, {
    ...param,
  });
  return res.data;
};

export { httpAPI_FAC030, httpAPI_FAC031, httpAPI_FAC014 };
